import React, { useEffect, useState } from 'react';
import { Map } from 'leaflet';
import { initializeBingLayer } from './functions/initializeBingLayer';

interface BingLayerProps {
    map: Map;
    mapTileUrl: string;
    isHideMapTiles: boolean;
}
const BingLayer: React.FC<BingLayerProps> = ({ map, mapTileUrl, isHideMapTiles }) => {
    const [bingLayer, setBingLayer] = useState<any>();

    useEffect(() => {
        if (mapTileUrl === 'bing' && !isHideMapTiles) {
            setBingLayer(initializeBingLayer());
        } else {
            bingLayer && map.removeLayer(bingLayer);
        }
    }, [mapTileUrl]);

    useEffect(() => {
        if (bingLayer && !isHideMapTiles) {
            bingLayer.addTo(map);
        }
    }, [bingLayer]);

    return null;
};

export default BingLayer;
